module.exports = __webpack_public_path__ + "static/media/scary_1.222c2d65.jpg";